import { InstructionsCtrl } from './instructions.controller';

export const InstructionsStepComponent = {
  controller: InstructionsCtrl,
  bindings: {
    nextStep: '&',
  },
  template: require('./instructions.html'),
};
